import React from 'react';
import {useRegistrationSteps} from "../../utilities/context/registration-steps/registration-steps-context";

const WaitingForConfirmationMessage = ({email}) => {

    const {registrationError} = useRegistrationSteps();

    const resetRegistrationStatus = () => {
        localStorage.clear();
        window.location.href = "";
    }

    return (
        <div>
            <div className="mb-4">
                {registrationError ?
                    <div>
                        <div className="font-medium text-xl mb-2">La tua registrazione non è andata a buon fine</div>
                        <div className="font-bold text-red-600">{registrationError}</div>
                    </div>
                    :
                    <div>Ti abbiamo inviato una mail all'indirizzo email {email ?? "- email non rilevata - "}. Verifica
                        la tua email per continuare il processo di registrazione.
                    </div>
                }
            </div>

            {/*<div className="cursor-pointer text-blue-600 hover:text-blue-500">Se la mail non ti arriva premi qui per*/}
            {/*    rieffettuare l'invio.*/}
            {/*</div>*/}
            {/*<div>oppure</div>*/}
            <div className="cursor-pointer text-blue-600 hover:text-blue-500 text-xs mt-8"
                 onClick={resetRegistrationStatus}>Ripeti il processo di registrazione.
            </div>
        </div>
    );
};

export default WaitingForConfirmationMessage;